import { c as _c } from "react/compiler-runtime";
import { FileSourceEnum } from '@systemeio/file-manager';
import { Checkbox, FormInput, FormSelect, Hint } from '@systemeio/ui';
import ItemSteps, { ItemStepsProps } from 'modules/stores/store/components/item-steps';
import { StoreTextEditor } from 'modules/stores/store/components/store-text-editor';
import { ReactNode, useEffect } from 'react';
import CodeEditor from 'shared/components/code-editor';
import ConfirmationModal from 'shared/components/confirmation-modal';
import { ImageUploaderWithPreviewImage } from 'shared/components/file-uploader/image-uploader-with-preview-image';
import FormUrlPathInput from 'shared/components/form-url-path-input';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useUserDomains from 'shared/hooks/use-user-domains';
import { getFormSelectData } from 'shared/utils/get-form-select-data';
import { twJoin, twMerge } from 'tailwind-merge';
import { useCourse } from '../../../hooks/use-course';
import { CourseId } from '../../../types/course-interface';
import { useSaveOnBlur } from './use-save-on-blur';
import { useSaveOnSubmit } from './use-save-on-submit';
interface Props extends Pick<ItemStepsProps, 'hideNumbers' | 'useSectionHeading'> {
  courseId?: CourseId;
  showDomain?: boolean;
  showNameAndDescription?: boolean;
  saveOnBlur?: boolean;
  additionalItems?: {
    key: string;
    title: ReactNode;
    element: ReactNode;
  }[];
  onStatusChange?: (_: {
    isFetching: boolean;
    disabled: boolean;
  }) => void;
}
export const LightCourseSettings = t0 => {
  const $ = _c(132);
  const {
    courseId,
    showDomain: t1,
    showNameAndDescription: t2,
    hideNumbers,
    useSectionHeading,
    saveOnBlur: t3,
    additionalItems,
    onStatusChange
  } = t0;
  const showDomain = t1 === undefined ? false : t1;
  const showNameAndDescription = t2 === undefined ? false : t2;
  const saveOnBlur = t3 === undefined ? true : t3;
  const {
    t
  } = useLocoTranslation();
  const {
    courseData,
    isLoading
  } = useCourse(courseId);
  const {
    userDomains
  } = useUserDomains();
  let t4;
  if ($[0] !== courseId) {
    t4 = {
      courseId
    };
    $[0] = courseId;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const onBlurSaver = useSaveOnBlur(t4);
  let t5;
  if ($[2] !== courseId) {
    t5 = {
      courseId
    };
    $[2] = courseId;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  const onSubmitSaver = useSaveOnSubmit(t5);
  const {
    tempState,
    setTempState,
    domainConfirmationModal,
    errors,
    isSuccess,
    statusIcon,
    handleBlur,
    isInProgress,
    isFetching,
    handleTeacherPhotoChange,
    handleCourseLogoChange,
    handleCourseCoverChange,
    handleCertificateLogoChange,
    handleSignatureChange,
    handleDomainChange,
    handleDomainChangeConfirm,
    handleIssueCertificateUponCompletionChange,
    handleFormSubmit,
    isCodeValid,
    setIsCodeValid
  } = saveOnBlur ? {
    ...onBlurSaver,
    handleFormSubmit: undefined,
    isFetching: undefined
  } : {
    ...onSubmitSaver,
    isSuccess: undefined,
    statusIcon: undefined,
    handleBlur: undefined,
    isInProgress: undefined
  };
  useEffect(() => {
    if (onStatusChange) {
      onStatusChange({
        isFetching: isFetching ?? false,
        disabled: !isCodeValid
      });
    }
  }, [isFetching, isCodeValid]);
  let t6;
  if ($[4] !== t) {
    t6 = t("dashboard.light_course.instructor_info");
    $[4] = t;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== t) {
    t7 = t("dashboard.light_course.instructor_name");
    $[6] = t;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== t) {
    t8 = t("dashboard.light_course.instructor_name");
    $[8] = t;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== t) {
    t9 = t("dashboard.settings.membership.teacher_photo_popover_title");
    $[10] = t;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== t) {
    t10 = t("dashboard.settings.membership.teacher_photo_title");
    $[12] = t;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== t10 || $[15] !== t9) {
    t11 = <Hint label={t9}>{t10}</Hint>;
    $[14] = t10;
    $[15] = t9;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] !== t) {
    t12 = t("dashboard.light_course.branding_settings");
    $[17] = t;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  if ($[19] !== t) {
    t13 = t("dashboard.course.logo_popover_title");
    $[19] = t;
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  let t14;
  if ($[21] !== t) {
    t14 = t("dashboard.course.logo_title");
    $[21] = t;
    $[22] = t14;
  } else {
    t14 = $[22];
  }
  let t15;
  if ($[23] !== t13 || $[24] !== t14) {
    t15 = <Hint label={t13}>{t14}</Hint>;
    $[23] = t13;
    $[24] = t14;
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  let t16;
  if ($[26] !== t) {
    t16 = t("dashboard.course.image_popover_title");
    $[26] = t;
    $[27] = t16;
  } else {
    t16 = $[27];
  }
  let t17;
  if ($[28] !== t) {
    t17 = t("dashboard.course.image_title");
    $[28] = t;
    $[29] = t17;
  } else {
    t17 = $[29];
  }
  let t18;
  if ($[30] !== t16 || $[31] !== t17) {
    t18 = <Hint label={t16}>{t17}</Hint>;
    $[30] = t16;
    $[31] = t17;
    $[32] = t18;
  } else {
    t18 = $[32];
  }
  const t19 = "certificate";
  let t20;
  if ($[33] !== t) {
    t20 = t("dashboard.light_course.certificate_settings");
    $[33] = t;
    $[34] = t20;
  } else {
    t20 = $[34];
  }
  const t21 = "flex flex-col gap-5";
  const T0 = Checkbox;
  let t22;
  if ($[35] !== t) {
    t22 = t("dashboard.course.issue_certificate_upon_completion_title");
    $[35] = t;
    $[36] = t22;
  } else {
    t22 = $[36];
  }
  const t23 = !!tempState?.issueCertificateUponCompletion;
  const t24 = !courseData;
  const t25 = isInProgress?.issueCertificateUponCompletion;
  const t26 = errors?.issueCertificateUponCompletion;
  const t27 = twMerge(isInProgress?.issueCertificateUponCompletion && "animate-pulse");
  let t28;
  if ($[37] !== T0 || $[38] !== handleIssueCertificateUponCompletionChange || $[39] !== t22 || $[40] !== t23 || $[41] !== t24 || $[42] !== t25 || $[43] !== t26 || $[44] !== t27) {
    t28 = <T0 label={t22} value={t23} onChange={handleIssueCertificateUponCompletionChange} disabled={t24} isFetching={t25} error={t26} inputWrapperClassName={t27} />;
    $[37] = T0;
    $[38] = handleIssueCertificateUponCompletionChange;
    $[39] = t22;
    $[40] = t23;
    $[41] = t24;
    $[42] = t25;
    $[43] = t26;
    $[44] = t27;
    $[45] = t28;
  } else {
    t28 = $[45];
  }
  let t29;
  if ($[46] !== t) {
    t29 = t("dashboard.course.certificate_logo_popover_title");
    $[46] = t;
    $[47] = t29;
  } else {
    t29 = $[47];
  }
  let t30;
  if ($[48] !== t) {
    t30 = t("dashboard.course.certificate_logo_title");
    $[48] = t;
    $[49] = t30;
  } else {
    t30 = $[49];
  }
  let t31;
  if ($[50] !== t29 || $[51] !== t30) {
    t31 = <Hint label={t29}>{t30}</Hint>;
    $[50] = t29;
    $[51] = t30;
    $[52] = t31;
  } else {
    t31 = $[52];
  }
  const t32 = tempState?.certificateLogo;
  let t33;
  if ($[53] !== handleCertificateLogoChange) {
    t33 = () => {
      handleCertificateLogoChange();
    };
    $[53] = handleCertificateLogoChange;
    $[54] = t33;
  } else {
    t33 = $[54];
  }
  const t34 = !courseData || isInProgress?.certificateLogo;
  const t35 = errors?.certificateLogo;
  const t36 = isSuccess?.certificateLogo;
  const t37 = statusIcon?.certificateLogo;
  let t38;
  if ($[55] !== handleCertificateLogoChange || $[56] !== isLoading || $[57] !== t31 || $[58] !== t32 || $[59] !== t33 || $[60] !== t34 || $[61] !== t35 || $[62] !== t36 || $[63] !== t37) {
    t38 = <ImageUploaderWithPreviewImage className="w-full" label={t31} value={t32} onRemove={t33} onSelect={handleCertificateLogoChange} source={FileSourceEnum.Membership} isPreFetching={isLoading} disabled={t34} error={t35} isSuccess={t36} statusIcon={t37} />;
    $[55] = handleCertificateLogoChange;
    $[56] = isLoading;
    $[57] = t31;
    $[58] = t32;
    $[59] = t33;
    $[60] = t34;
    $[61] = t35;
    $[62] = t36;
    $[63] = t37;
    $[64] = t38;
  } else {
    t38 = $[64];
  }
  let t39;
  if ($[65] !== t) {
    t39 = t("dashboard.course.signature_popover_title");
    $[65] = t;
    $[66] = t39;
  } else {
    t39 = $[66];
  }
  let t40;
  if ($[67] !== t) {
    t40 = t("dashboard.course.signature_title");
    $[67] = t;
    $[68] = t40;
  } else {
    t40 = $[68];
  }
  let t41;
  if ($[69] !== t39 || $[70] !== t40) {
    t41 = <Hint label={t39}>{t40}</Hint>;
    $[69] = t39;
    $[70] = t40;
    $[71] = t41;
  } else {
    t41 = $[71];
  }
  const t42 = tempState?.signature;
  let t43;
  if ($[72] !== handleSignatureChange) {
    t43 = () => {
      handleSignatureChange();
    };
    $[72] = handleSignatureChange;
    $[73] = t43;
  } else {
    t43 = $[73];
  }
  const t44 = !courseData || isInProgress?.signature;
  const t45 = errors?.signature;
  const t46 = isSuccess?.signature;
  const t47 = statusIcon?.signature;
  let t48;
  if ($[74] !== handleSignatureChange || $[75] !== isLoading || $[76] !== t41 || $[77] !== t42 || $[78] !== t43 || $[79] !== t44 || $[80] !== t45 || $[81] !== t46 || $[82] !== t47) {
    t48 = <ImageUploaderWithPreviewImage className="w-full" label={t41} value={t42} onRemove={t43} onSelect={handleSignatureChange} source={FileSourceEnum.Membership} isPreFetching={isLoading} disabled={t44} error={t45} isSuccess={t46} statusIcon={t47} />;
    $[74] = handleSignatureChange;
    $[75] = isLoading;
    $[76] = t41;
    $[77] = t42;
    $[78] = t43;
    $[79] = t44;
    $[80] = t45;
    $[81] = t46;
    $[82] = t47;
    $[83] = t48;
  } else {
    t48 = $[83];
  }
  let t49;
  if ($[84] !== t38 || $[85] !== t48) {
    t49 = <div className="flex flex-col gap-5 sm:flex-row">{t38}{t48}</div>;
    $[84] = t38;
    $[85] = t48;
    $[86] = t49;
  } else {
    t49 = $[86];
  }
  let t50;
  if ($[87] !== t28 || $[88] !== t49) {
    t50 = <div className={t21}>{t28}{t49}</div>;
    $[87] = t28;
    $[88] = t49;
    $[89] = t50;
  } else {
    t50 = $[89];
  }
  let t51;
  if ($[90] !== t20 || $[91] !== t50) {
    t51 = {
      key: t19,
      title: t20,
      element: t50
    };
    $[90] = t20;
    $[91] = t50;
    $[92] = t51;
  } else {
    t51 = $[92];
  }
  let t52;
  if ($[93] !== t) {
    t52 = t("dashboard.light_course.custom_code");
    $[93] = t;
    $[94] = t52;
  } else {
    t52 = $[94];
  }
  const t53 = tempState?.embeddedCode;
  let t54;
  if ($[95] !== t) {
    t54 = t("dashboard.course.embedded_code_popover_title");
    $[95] = t;
    $[96] = t54;
  } else {
    t54 = $[96];
  }
  let t55;
  if ($[97] !== t) {
    t55 = t("dashboard.course.embedded_code_title");
    $[97] = t;
    $[98] = t55;
  } else {
    t55 = $[98];
  }
  let t56;
  if ($[99] !== t54 || $[100] !== t55) {
    t56 = <Hint label={t54}>{t55}</Hint>;
    $[99] = t54;
    $[100] = t55;
    $[101] = t56;
  } else {
    t56 = $[101];
  }
  let t57;
  if ($[102] !== setTempState) {
    t57 = value_0 => setTempState(prev_3 => ({
      ...prev_3,
      embeddedCode: value_0
    }));
    $[102] = setTempState;
    $[103] = t57;
  } else {
    t57 = $[103];
  }
  const t58 = handleBlur?.embeddedCode;
  const t59 = isLoading || !courseData;
  const t60 = errors?.embeddedCode;
  const t61 = isSuccess?.embeddedCode;
  const t62 = statusIcon?.embeddedCode;
  let t63;
  if ($[104] !== setIsCodeValid || $[105] !== t53 || $[106] !== t56 || $[107] !== t57 || $[108] !== t58 || $[109] !== t59 || $[110] !== t60 || $[111] !== t61 || $[112] !== t62) {
    t63 = <CodeEditor value={t53} label={t56} onChange={t57} onBlur={t58} setIsValid={setIsCodeValid} disabled={t59} error={t60} isSuccess={t61} statusIcon={t62} />;
    $[104] = setIsCodeValid;
    $[105] = t53;
    $[106] = t56;
    $[107] = t57;
    $[108] = t58;
    $[109] = t59;
    $[110] = t60;
    $[111] = t61;
    $[112] = t62;
    $[113] = t63;
  } else {
    t63 = $[113];
  }
  let t64;
  if ($[114] !== t52 || $[115] !== t63) {
    t64 = {
      key: "code",
      title: t52,
      element: t63
    };
    $[114] = t52;
    $[115] = t63;
    $[116] = t64;
  } else {
    t64 = $[116];
  }
  let t65;
  if ($[117] !== additionalItems) {
    t65 = additionalItems ?? [];
    $[117] = additionalItems;
    $[118] = t65;
  } else {
    t65 = $[118];
  }
  const fields = [{
    key: "teacher",
    title: t6,
    element: <div className="flex flex-col gap-5 sm:flex-row"><FormInput className="w-full" label={t7} value={tempState?.instructorName ?? ""} placeholder={t8} onChange={e => setTempState(prev => ({
        ...prev,
        instructorName: e.target.value ?? ""
      }))} onBlur={e_0 => handleBlur?.instructorName(e_0.target.value)} isPreFetching={isLoading} disabled={!courseData} error={errors?.instructorName} success={isSuccess?.instructorName} statusIcon={statusIcon?.instructorName} /><ImageUploaderWithPreviewImage className="w-full" previewClassName="h-[200px] w-[200px]" source={FileSourceEnum.Membership} aspectRatio={1} label={t11} value={tempState?.teacherPhoto} onRemove={() => {
        handleTeacherPhotoChange();
      }} onSelect={handleTeacherPhotoChange} isPreFetching={isLoading} disabled={!courseData || isInProgress?.teacherPhoto} error={errors?.teacherPhoto} isSuccess={isSuccess?.teacherPhoto} statusIcon={statusIcon?.teacherPhoto} /></div>
  }, {
    key: "course",
    title: t12,
    element: <>{showDomain && <div className="flex flex-col flex-wrap gap-5 sm:flex-row"><FormSelect data={getFormSelectData(userDomains || [])} label={t("dashboard.course.course_domain_title")} className="sm:min-w-0" containerClassName="min-w-[200px] flex-1" required={true} value={tempState?.domainId || undefined} onChange={handleDomainChange} isPreFetching={isLoading} disabled={!courseData} withoutCloseIcon={true} /><ConfirmationModal title={t("dashboard.course.course_domain_confirm_title")} confirmationText={t("dashboard.course.course_domain_confirmation_text_title")} opened={domainConfirmationModal.opened} toastCaption={saveOnBlur && t("global.changes_saved")} onClose={domainConfirmationModal.close} onConfirm={handleDomainChangeConfirm} /><FormUrlPathInput wrapperClassName="flex-1" value={tempState?.path} onChange={e_1 => setTempState(prev_0 => ({
          ...prev_0,
          path: e_1.target.value
        }))} onBlur={e_2 => handleBlur?.path(e_2.target.value)} label={<><div className="flex items-center gap-1.5">{t("global.url_path")}<Hint label={t("dashboard.funnel.configuration.webinar.url_path_popover-2")} /></div></>} required={true} domainName={userDomains?.find(el => el.id === tempState?.domainId)?.name} additionalPath="school/course" isPreFetching={isLoading} disabled={!courseData || isInProgress?.path} error={errors?.path} success={isSuccess?.path} statusIcon={statusIcon?.path} copyButtonClassName={twJoin(isSuccess?.path && "[&>svg]:stroke-background-secondary")} /></div>}{showNameAndDescription && <div className="flex flex-col gap-5"><FormInput label={t("dashboard.light_course.course_title")} required={true} value={tempState?.name ?? ""} placeholder={t("dashboard.light_course.course_title")} onChange={e_3 => setTempState(prev_1 => ({
          ...prev_1,
          name: e_3.target.value
        }))} onBlur={e_4 => handleBlur?.name(e_4.target.value)} isPreFetching={isLoading} disabled={!courseData} error={errors?.name} success={isSuccess?.name} statusIcon={statusIcon?.name} /><StoreTextEditor label={t("dashboard.course.description_title")} required={true} content={tempState?.description ?? ""} onChange={value => setTempState(prev_2 => ({
          ...prev_2,
          description: value
        }))} onBlur={handleBlur?.description} isPreFetching={isLoading} className={twMerge(isSuccess?.description && "border-success", errors?.description !== undefined && "border-danger")} error={errors?.description} statusIcon={statusIcon?.description} /></div>}<div className="flex flex-col gap-5 xl:flex-row"><ImageUploaderWithPreviewImage className="w-full" previewClassName="w-[364px] h-[200px] !object-contain object-top" source={FileSourceEnum.Membership} label={t15} value={tempState?.logo} onRemove={() => {
          handleCourseLogoChange();
        }} onSelect={handleCourseLogoChange} isPreFetching={isLoading} disabled={!courseData || isInProgress?.logo} error={errors?.logo} isSuccess={isSuccess?.logo} statusIcon={statusIcon?.logo} /><ImageUploaderWithPreviewImage className="w-full" previewClassName="h-[200px] w-[364px]" label={t18} aspectRatio={1.7777777777777777} value={tempState?.image} source={FileSourceEnum.Membership} onRemove={() => {
          handleCourseCoverChange();
        }} onSelect={handleCourseCoverChange} isPreFetching={isLoading} disabled={!courseData || isInProgress?.image} error={errors?.image} isSuccess={isSuccess?.image} statusIcon={statusIcon?.image} /></div></>
  }, t51, t64, ...t65].filter(Boolean) as {
    key: string;
    title: ReactNode;
    element: ReactNode;
  }[];
  if (saveOnBlur) {
    let t66;
    if ($[119] !== fields || $[120] !== hideNumbers || $[121] !== useSectionHeading) {
      t66 = <ItemSteps steps={fields} hideNumbers={hideNumbers} useSectionHeading={useSectionHeading} />;
      $[119] = fields;
      $[120] = hideNumbers;
      $[121] = useSectionHeading;
      $[122] = t66;
    } else {
      t66 = $[122];
    }
    return t66;
  }
  let t66;
  if ($[123] !== handleFormSubmit) {
    t66 = e_5 => {
      e_5.preventDefault();
      handleFormSubmit?.();
    };
    $[123] = handleFormSubmit;
    $[124] = t66;
  } else {
    t66 = $[124];
  }
  let t67;
  if ($[125] !== fields || $[126] !== hideNumbers || $[127] !== useSectionHeading) {
    t67 = <ItemSteps steps={fields} hideNumbers={hideNumbers} useSectionHeading={useSectionHeading} />;
    $[125] = fields;
    $[126] = hideNumbers;
    $[127] = useSectionHeading;
    $[128] = t67;
  } else {
    t67 = $[128];
  }
  let t68;
  if ($[129] !== t66 || $[130] !== t67) {
    t68 = <form id={LightCourseSettings.formId} onSubmit={t66}>{t67}</form>;
    $[129] = t66;
    $[130] = t67;
    $[131] = t68;
  } else {
    t68 = $[131];
  }
  return t68;
};
LightCourseSettings.formId = 'light-course-settings-form';